import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ShortlistToggle } from '@shared-ui/trip-planning-travelpulse';
import { Source, TripSaveItem } from '@shared-ui/trips-save-item';

import { ShortlistModel } from 'models';

import { ProductType } from '__generated__/api';

export interface FavoriteButtonProps {
  analytics?: AnalyticsStore;
  shortlistModel: ShortlistModel;
  label: string;
  onSaveMessage: string;
  rfrrPrefix?: string;
}

@inject('analytics')
@observer
export class FavoriteButton extends React.Component<FavoriteButtonProps> {
  private handleOnChange = (checked: boolean, prevChecked: boolean, dispatch: ({ message: string }) => void) => {
    const { analytics, onSaveMessage, rfrrPrefix } = this.props;

    if (!checked && prevChecked) {
      dispatch({ message: onSaveMessage });
    }

    const referrerId = rfrrPrefix ? rfrrPrefix : 'Shortlist-Toggle';

    const rfrr = checked ? `${referrerId}.RemoveFavorite` : `${referrerId}.SaveFavorite`;
    const linkName = checked ? 'Shortlist-Toggle.Remove from favorite lists' : 'Shortlist-Toggle.Add to favorite lists';

    analytics.trackEvent(rfrr, linkName, null, null, true);
  };

  public shouldComponentUpdate(nextProps): boolean {
    return this.props !== nextProps;
  }

  public render() {
    const { shortlistModel } = this.props;

    const meta = shortlistModel && shortlistModel.meta;
    const metadata = Object.entries(meta).map(kv => ({
      key: kv[0],
      value: kv[1],
    }));
    const inputs = {
      metadata,
      productId: meta && meta.hotelId,
      productType: ProductType.PROPERTY_DETAILS,
    };

    return (
      <Experiment name="SDUI_TRIP_PLANNING_THROTTLE_PWA">
        <ExperimentControl>
          <ShortlistToggle
            inputs={inputs}
            initialChecked={shortlistModel && shortlistModel.favorited}
            onChange={this.handleOnChange}
            label={this.props.label}
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <TripSaveItem
            label={this.props.label}
            inputs={{
              item: {
                itemId: inputs.productId,
                source: Source.HOTEL_SEARCH,
              },
            }}
          />
        </ExperimentVariant>
      </Experiment>
    );
  }
}
